import React from "react";
import {
  TextField,
  Button,
  Typography,
  Stack,
  Box,
  Divider,
} from "@mui/material";
import { useFormikContext, FieldArray } from "formik";
import { fieldConfig } from "../config/fieldConfig";

const AdditionalInfoSection = () => {
  const { values, handleChange, touched, errors, getFieldProps } =
    useFormikContext();

  const contact = values.additional?.contact || {};
  const tags = values.additional?.tags || [];

  return (
    <Box mt={4}>
      <Typography variant="h6" gutterBottom>
        Additional Info
      </Typography>

      <Typography variant="body2" color="textSecondary" gutterBottom>
        Provide any extra details about your tour, including specific
        requirements, cancellation policies, contact information, and relevant
        tags for better categorization and discovery of your tour.
      </Typography>

      <TextField
        fullWidth
        multiline
        minRows={2}
        label={fieldConfig.additional.requirements.label}
        name="additional.requirements"
        {...getFieldProps("additional.requirements")}
        error={
          touched?.additional?.requirements &&
          Boolean(errors?.additional?.requirements)
        }
        // helperText={
        //   touched?.additional?.requirements && errors?.additional?.requirements
        // }
        margin="normal"
        placeholder={fieldConfig.additional.requirements.placeholder}
        helperText={fieldConfig.additional.requirements.helperText}
      />

      <TextField
        fullWidth
        multiline
        minRows={2}
        label={fieldConfig.additional.cancellationPolicy.label}
        name="additional.cancellationPolicy"
        {...getFieldProps("additional.cancellationPolicy")}
        error={
          touched?.additional?.cancellationPolicy &&
          Boolean(errors?.additional?.cancellationPolicy)
        }
        margin="normal"
        placeholder={fieldConfig.additional.cancellationPolicy.placeholder}
        helperText={
          touched?.additional?.cancellationPolicy && errors?.additional?.cancellationPolicy
            ? errors.additional.cancellationPolicy
            : fieldConfig.additional.cancellationPolicy.helperText
        }
      />

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle1" gutterBottom>
        Contact Info
      </Typography>

      <TextField
        fullWidth
        label={fieldConfig.additional.contact.name.label}
        name="additional.contact.name"
        {...getFieldProps("additional.contact.name")}
        error={
          touched?.additional?.contact?.name &&
          Boolean(errors?.additional?.contact?.name)
        }
        // helperText={
        //   touched?.additional?.contact?.name &&
        //   errors?.additional?.contact?.name
        // }
        margin="normal"
        placeholder={fieldConfig.additional.contact.name.placeholder}
        helperText={fieldConfig.additional.contact.name.helperText}
      />

      <TextField
        fullWidth
        label={fieldConfig.additional.contact.phone.label}
        name="additional.contact.phone"
        {...getFieldProps("additional.contact.phone")}
        error={
          touched?.additional?.contact?.phone &&
          Boolean(errors?.additional?.contact?.phone)
        }
        // helperText={
        //   touched?.additional?.contact?.phone &&
        //   errors?.additional?.contact?.phone
        // }
        margin="normal"
        placeholder={fieldConfig.additional.contact.phone.placeholder}
        helperText={fieldConfig.additional.contact.phone.helperText}
      />

      <TextField
        fullWidth
        label={fieldConfig.additional.contact.email.label}
        name="additional.contact.email"
        {...getFieldProps("additional.contact.email")}
        error={
          touched?.additional?.contact?.email &&
          Boolean(errors?.additional?.contact?.email)
        }
        // helperText={
        //   touched?.additional?.contact?.email &&
        //   errors?.additional?.contact?.email
        // }
        margin="normal"
        placeholder={fieldConfig.additional.contact.email.placeholder}
        helperText={fieldConfig.additional.contact.email.helperText}
      />

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle1" gutterBottom>
        Tags
      </Typography>
      <FieldArray name="additional.tags">
        {({ push, remove }) => (
          <Stack direction="column" spacing={2}>
            {tags.map((tag, index) => (
              <Box key={index} display="flex" gap={2} alignItems="center">
                <TextField
                  label={`${fieldConfig.additional.tags.label} ${index + 1}`}
                  name={`additional.tags[${index}]`}
                  value={tag}
                  onChange={handleChange}
                  fullWidth
                  placeholder={fieldConfig.additional.tags.placeholder}
                  helperText={fieldConfig.additional.tags.helperText}
                />
                <Button
                  color="error"
                  onClick={() => remove(index)}
                  variant="outlined"
                >
                  Remove
                </Button>
              </Box>
            ))}
            <Button onClick={() => push("")} variant="outlined">
              Add Tag
            </Button>
          </Stack>
        )}
      </FieldArray>
    </Box>
  );
};

export default AdditionalInfoSection;
